import { render, staticRenderFns } from "./LeisuresComponent.vue?vue&type=template&id=548fc526&scoped=true"
import script from "./LeisuresComponent.vue?vue&type=script&lang=js"
export * from "./LeisuresComponent.vue?vue&type=script&lang=js"
import style0 from "./LeisuresComponent.vue?vue&type=style&index=0&id=548fc526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548fc526",
  null
  
)

export default component.exports